import BaseAPI from "../base";

class BookingDiagnoseService extends BaseAPI {
  // 上传附件
  uploadDocument(params, onUploadProgress) {
    return this.post({
      url: `${process.env.VUE_APP_MG_APIBASEURL}/BookingDiagnose/UploadDocument`,

      data: params,
      onUploadProgress,
    });
  }
  // 医生-列表
  doctorList(params) {
    return this.post({
      url: `${process.env.VUE_APP_MG_APIBASEURL}/BookingDiagnose/DoctorList`,
      data: params,
    });
  }
  // 医生-排班
  doctorScheduling(params) {
    return this.post({
      url: `${process.env.VUE_APP_MG_APIBASEURL}/BookingDiagnose/HisSchedules`,
      data: params,
    });
  }
  // 科室-列表
  departmentList(params) {
    return this.post({
      url: `${process.env.VUE_APP_MG_APIBASEURL}/BookingDiagnose/DepartmentList`,
      data: params,
    });
  }
  // 预约看诊-添加
  bookingDiagnoseAdd(params) {
    return this.post({
      url: `${process.env.VUE_APP_MG_APIBASEURL}/BookingDiagnose/BookingDiagnoseAdd`,
      data: params,
    });
  }
  // 预约看诊-列表
  bookingDiagnoseList(params) {
    return this.post({
      url: `${process.env.VUE_APP_MG_APIBASEURL}/BookingDiagnose/BookingDiagnoseList`,
      data: params,
    });
  }
  // 预约看诊-取消
  bookingDiagnoseCancel(params) {
    return this.post({
      url: `${process.env.VUE_APP_MG_APIBASEURL}/BookingDiagnose/BookingDiagnoseCancel`,
      data: params,
    });
  }
  // 疾病列表
  bookingDiagnoseRetrievalList(params) {
    return this.post({
      url: `${process.env.VUE_APP_MG_APIBASEURL}/BookingDiagnose/RetrievalList`,
      data: params,
    });
  }
}

export default new BookingDiagnoseService();
